<template>
  <div>
    <!-- <InterForm @querySubmit="queryHandler" @overEmit="getDataSource" :prentType="prentType" :shopList="shopList" /> -->
    <!--    FBA -&ndash;&gt; 打标中： 有 '导出发货单'、'批量修改物流公司'-->
    <!--    大包 -&ndash;&gt; 打标中： 有 '导出发货单'、'批量修改物流公司'-->
    <!--    小包 -&ndash;&gt; ,没有打标中 -->
    <InterBtnBox :selectedRows="selectedRows" @overEmit="getDataSource" modify-btn :prentType="prentType"
      :singleProduct="query.singleProduct" @refeash="getDataSource" />
    <InterList :dataSource="dataSource" tableType="marking" :clean="clean" @pageChange="pageChangeCall"
      :singleProduct="query.singleProduct" @selectChange="selectChangeCall" @change="getDataSource" layout="logistics"
      @refeash="getDataSource" :prentType="prentType" ref="interlist" :forwarder="$attrs.forwarder" :total="query.total"></InterList>
  </div>
</template>

<script>
import InterForm from "@/views/outOfStock/internationalShipment/components/InterForm";
import InterList from "@/views/outOfStock/internationalShipment/components/InterList";
import InterBtnBox from "@/views/outOfStock/internationalShipment/components/InterBtnBox";
import { deliveryStatus, deliveryTypes } from "@/views/outOfStock/internationalShipment/tabs/index";
import { shipTask } from "@/apis/outStock";

export default {
  title: '打标中',
  name: "marking", // 打标中
  components: {
    InterForm,
    InterList,
    InterBtnBox
  },
  props: {
    prentType: String,
    shopList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      query: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      clean: false,
      selectedRows: [],
      dataSource: []
    }
  },
  methods: {
    queryHandler: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      }
      this.query.current = 1
      this.getDataSource()
      if (this.$refs.interlist) {
        this.$refs.interlist.resetPage()
      }
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource()
    },
    selectChangeCall: function (rows) {
      this.selectedRows = rows
    },
    getDataSource: function () {
      // console.log(this.query)
      // 获取列表数据
      this.selectedRows = []
      const params = {
        ...this.query,
        pageNum: this.query.current,
        deliveryStatus: deliveryStatus['marking'],
        deliveryType: deliveryTypes[this.prentType]
      }
      this.clean = true
      shipTask(params).then(res => {
        const { data: { total = 0, records = [] } } = res
        records.forEach(item => {
          let text = ''
          if (item.channelNo && item.logisticsChannelDTOList) {
            item.logisticsChannelDTOList.forEach(item_son => {
              if (item_son.channelNo == item.channelNo) {
                text = item_son.channelName
              }
            })
          }
          item.channelNo = text
        })
        this.query.total = total
        this.dataSource = records
        // const {}
      }).finally(_ => {
        this.clean = false
      })
    },
  }
}
</script>

<style scoped>
</style>